import { useManagementClients } from "../../Queries/ClientQueries";

/**
 * Returns whether the current user is a super user.
 *
 * Mirrors the access check each `/admin` page already performs (`useManagementClients` returning
 * a non-empty list of management clients), so features gated on "super user" stay consistent with
 * existing admin-page access control instead of depending on the (not yet rolled out) ABAC system.
 */
export function useIsSuperUser(): boolean {
  const { data: managementClients } = useManagementClients();
  return !!managementClients && managementClients.length > 0;
}
